import capitalize from 'lodash/capitalize';
import { PAYMENT_INTENT_STATUSES } from './constants';

export const getPendingIntentTransactionId = intents =>
  intents?.find(intent => intent.status === PAYMENT_INTENT_STATUSES.pending)
    ?.transaction_id;

export const getPendingIntentInternalId = intents =>
  intents?.find(intent => intent.status === PAYMENT_INTENT_STATUSES.pending)
    ?.id;

export const getSetupIntentTransactionId = setupIntent => {
  const parts = setupIntent?.transaction_id.split('_secret_');
  return parts[0];
};

export const ALTERNATIVE_PAYMENT_DESCRIPTION = {
  ShopPay: 'Paying with Shop Pay',
  PayPal: 'Paying with Pay Pal',
};

// AMEX cards return as american_express from the BE
const getPaymentMethodBrand = brand => {
  if (brand === 'american_express') return 'American Express';
  return capitalize(brand);
};

export const getPaymentMethodDescription = (brand, type, lastFourDigits) => {
  if (!!ALTERNATIVE_PAYMENT_DESCRIPTION[type]) {
    return ALTERNATIVE_PAYMENT_DESCRIPTION[type];
  } else {
    return `${getPaymentMethodBrand(brand)} ending in ••••${' '}
    ${lastFourDigits}`;
  }
};
